function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon/sf-small/law/zodiac",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}, /*#__PURE__*/React.createElement("line", {
  x1: 8.4141,
  y1: 7.4648,
  x2: 14.0711,
  y2: 1.8078,
  id: "Stroke-1",
  stroke: "#1B2559",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.6568,
  y1: 0.3936,
  x2: 15.4858,
  y2: 3.2216,
  id: "Stroke-3",
  stroke: "#1B2559",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 6.0498,
  x2: 9.829,
  y2: 8.8788,
  id: "Stroke-6",
  stroke: "#1B2559",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 11.2427,
  y1: 4.6357,
  x2: 19.2427,
  y2: 12.6357,
  id: "Stroke-7",
  stroke: "#1B2559",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 3,
  y1: 16.5,
  x2: 10,
  y2: 16.5,
  id: "Stroke-9",
  stroke: "#1B2559",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 19.5,
  x2: 13,
  y2: 19.5,
  id: "Stroke-10",
  stroke: "#1B2559",
  strokeWidth: 2
}));

function SvgZodiac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZodiac);
export default __webpack_public_path__ + "static/media/zodiac.96d45453.svg";
export { ForwardRef as ReactComponent };